import { apiSurveys } from "@/api/survey.api.ts";
import { FormProviderTypeUpdateParams } from "@/components/forms/form-editor.types.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Control, FieldValues } from "react-hook-form";

const surveyFormKeys = createQueryKeys("surveyForms", {
  byId: (id: number) => ({
    queryKey: [id],
    queryFn: async () => {
      const result = await apiSurveys.formGetById(id);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data!;
    },
  }),
});

export const useSurveyFormById = (id: number, enabled = true) => {
  return useQuery({
    ...surveyFormKeys.byId(id),
    enabled: !!id && enabled,
  });
};

export const useSurveyFormUpdate = <
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
>(
  control: Control<TFieldValues, TContext, TTransformedValues> | undefined = undefined
) => {
  const queryClient = useQueryClient();
  const { onError } = useErrorHandle();
  return useMutation({
    mutationFn: async function ({ id, payload }: FormProviderTypeUpdateParams) {
      const result = await apiSurveys.formUpdate(id, payload);
      if (result.error || !result.data) throw new ApiErrorException(result.error);
      // return result.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: surveyFormKeys.byId(variables.id).queryKey,
      });
    },
    onError: (error: Error) => {
      onError(error, control);
    },
  });
};
